import { render } from "./BaseTextarea.vue?vue&type=template&id=44fe767a"
const script = {}

import "./BaseTextarea.vue?vue&type=style&index=0&id=44fe767a&lang=scss"
script.render = render

export default script